import { usePosts } from '../hooks';
import { PostsFeed } from '../components';

export function HomePage() {
  const { posts, loading, error, hasMore, loadMore, loadingMore } = usePosts(10);

  return (
    <PostsFeed
      posts={posts}
      loading={loading}
      error={error}
      hasMore={hasMore}
      loadMore={loadMore}
      loadingMore={loadingMore}
    />
  );
}
